import { Component, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common'
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { GeoArea } from 'src/app/assabil-kernel/models/entities/control-tables/geo-area-entity';
import { GeoAreaLoyaltyProgramKpi } from 'src/app/assabil-sales/models/dtos/geo-area-loyalty-program-kpi';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { LeanDataFormComponent } from 'src/app/tools/components/lean-data-form/lean-data-form.component';
import { SpecificDanoneService } from 'src/app/assabil-sales/services/specific_danone_service';
import { DatepickerModule, MonthPickerComponent } from 'ngx-bootstrap/datepicker';


  @Component({
    selector: 'danone-loyalty-monitoring-widget',
    templateUrl: './danone-loyalty-monitoring-widget.component.html',
    styleUrls: ['./danone-loyalty-monitoring-widget.component.scss']
  })
  
  export class DanoneLoyaltyMonitoringWidgetComponent extends BaseWidget {

    @ViewChild('leanDataForm', {static : false}) leanDataForm : LeanDataFormComponent;
  
    geoArea             : GeoArea;
    selectedGeoArea     : GeoArea = null
    date                : Date = new Date();
    dateTemp            : Date = new Date();
    title               : string = "Suivi Quanti Toujjar Bladi";
    previousPeriod      : string = "12/2030";

    loyaltyProgram : string;
    geoAreaCode    : string;
    kpi            : string;
    periodActiveDay: Date;

    geoAreaLoyaltyProgramKpi :  GeoAreaLoyaltyProgramKpi;


    showPartnerList       : boolean = false;
    

    constructor(
      protected datepipe: DatePipe,
      protected specificDanoneService   : SpecificDanoneService,
      protected controlTablesService    : ControlTablesService,
      protected leanUtilsService        : LeanUtilsService,
      protected masterDataService       : MasterDataService,
      protected toastr                  : ToastrService,
      protected router                  : Router,
      protected location                : Location) {
        super(toastr, leanUtilsService);
        
  
    }
  
  //----------------------------------------------------------------------------------------------------------------------------------
  ngOnInit(){
    this.date.setDate(this.date.getDate() - 1);
    super.ngOnInit();
    this.controlTablesService.personGeoAreaGet().then(result => {
      this.geoArea = result;
    })
  }
  //----------------------------------------------------------------------------------------------------------------------------------


  //----------------------------------------------------------------------------------------------------------------------------------
  loadData() {
    if ( (! this.selectedGeoArea) ||   (! this.date) ){
      this.toastr.error("Prière de préciser les paramètres de la recherhe");
      return;
    }
    
    this.specificDanoneService.geoAreaLoyaltyProgramKpisGet(this.selectedGeoArea.geoAreaCode, this.date).then(geoAreaLoyaltyProgramKpi => {
        this.geoAreaLoyaltyProgramKpi = geoAreaLoyaltyProgramKpi;
    })
    this.dateTemp.setFullYear(this.date.getFullYear(), this.date.getMonth() - 1);
    this.title = "Suivi Quanti Toujjar Bladi - MTD : " + this.datepipe.transform(this.date, 'dd/MM/yyyy') + " | " + this.selectedGeoArea.name;
    this.previousPeriod = this.datepipe.transform(this.dateTemp, 'MMM');

    //console.log("this.previousPeriod : ", this.previousPeriod)
  }
 //----------------------------------------------------------------------------------------------------------------------------------

 //----------------------------------------------------------------------------------------------------------------------------------

click(event : any){
  this.loyaltyProgram  = event.loyaltyProgram;
  this.geoAreaCode     = event.geoArea.geoAreaCode;
  this.kpi             = event.kpi;
  this.periodActiveDay = this.date;
  this.showPartnerList = true;
}
//----------------------------------------------------------------------------------------------------------------------------------


  //----------------------------------------------------------------------
  selectGeoAreaAndGo(geoArea : GeoArea){ 
    this.selectGeoArea(geoArea);
    this.leanDataForm.hideFilter();
    this.loadData();
  }
  selectGeoArea(geoArea : GeoArea){
    if (this.selectedGeoArea != null) this.selectedGeoArea.selected = false;
    this.selectedGeoArea = geoArea;
    this.selectedGeoArea.selected=true;
  }
//----------------------------------------------------------------------


//--------------------------------------------------------------------------------------
returnBack(){
  this.location.back();
}
//--------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------
  setEntity(data: BaseEntity) {
    throw new Error("Method not implemented.");
  }
  getEntity(): BaseEntity {
    throw new Error("Method not implemented.");
  }
  saveRow(): Promise<BaseEntity> {
    throw new Error("Method not implemented.");
  }
  //--------------------------------------------------------------------------------------
    
  }
  
  